import React from 'react';

import { Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import BlockIcon from '@material-ui/icons/BlockOutlined';

import classes from '../../../css/getCSS';

const profileStatusChange = (props) => {
  let icon = null;

  if (props.activity.state.value === 1) {
    icon = <CheckIcon className={classes.profileStatusChangeIcon} />;
  }
  if (props.activity.state.value === 2) {
    icon = <CloseIcon className={classes.profileStatusChangeIcon} />;
  }
  if (props.activity.state.value === 3) {
    icon = <DeleteIcon className={classes.profileStatusChangeIcon} />;
  }
  if (props.activity.state.value === 4) {
    icon = <BlockIcon className={classes.profileStatusChangeIcon} />;
  }

  return (
    <div className={classes.padding20} style={{ textAlign: 'center' }}>
      {icon}
      <Typography variant="subheading" style={{ fontWeight: 'bold' }}>{props.activity.state.display}</Typography>
    </div>
  );
};

export default profileStatusChange;



// WEBPACK FOOTER //
// ./src/dashboard/components/activities/ProfileStatusChange.js